export default __webpack_public_path__ + "static/media/inter-v2-latin-regular.f54dfeb3.woff2";